export default __webpack_public_path__ + "static/media/Ies_panel_VictorPalacios.b480ebee.png";